import React from 'react';
import { NavLink, NavLinkRenderProps,useNavigate  } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useApp } from '../../contexts/AppContext'; 
import styles from './Layout.module.css'; // سنستخدم نفس تنسيقات السايدبار الحالي
import { 
  FaTachometerAlt, 
  FaFileSignature, 
  FaFileInvoice, 
  FaCalendarPlus, 
  FaExclamationCircle ,
  FaSignOutAlt
} from 'react-icons/fa';
import Icon from '../common/Icon';


const LawyerSidebar: React.FC = () => {
    const { isSidebarOpen } = useApp();
    const { logout } = useAuth(); // 2. الحصول على دالة logout
    const navigate = useNavigate();
    const getNavLinkClass = ({ isActive }: NavLinkRenderProps): string => {
    return isActive ? `${styles.navLink} ${styles.active}` : styles.navLink;
  };

   // 3. إنشاء دالة لمعالجة تسجيل الخروج
  const handleLogout = () => {
    logout();
    // توجيه المستخدم إلى صفحة تسجيل الدخول بعد الخروج
    navigate('/login'); 
  };
  return (
    <aside className={`${styles.sidebar} ${isSidebarOpen ? styles.open : ''}`}>
        <div className={styles.logo}>
        <h3>لوحة التحكم</h3>
      </div>
      <div className={styles.sidebarMain}>
      <nav className={styles.nav}>
        
            <NavLink to="/lawyer/dashboard" className={getNavLinkClass}>
             <Icon as={FaTachometerAlt} style={styles.icon} />
              <span>لوحة التحكم</span>
            </NavLink>
          
            <NavLink to="/lawyer/new-service-request" className={getNavLinkClass}>
              <Icon as={FaFileSignature} style={styles.icon} />
              <span>طلب خدمة جديد</span>
            </NavLink>
          
            <NavLink to="/lawyer/renew-subscription" className={getNavLinkClass}>
              <Icon as={FaCalendarPlus} style={styles.icon} />
              <span>تجديد الاشتراك</span>
            </NavLink>
          
            <NavLink to="/lawyer/my-invoices" className={getNavLinkClass}>
              <Icon as={FaFileInvoice} style={styles.icon} />
              <span>فواتيري</span>
            </NavLink>
          
            <NavLink to="/lawyer/submit-complaint" className={getNavLinkClass}>
              <Icon as={FaExclamationCircle} style={styles.icon} />
              <span>تقديم شكوى</span>
            </NavLink>
        
      </nav>
      </div>
      <div className={styles.sidebarFooter}>
        <button onClick={handleLogout} className={styles.logoutButton}>
          <Icon as={FaSignOutAlt} />
          <span>تسجيل الخروج</span>
        </button>
      </div>
    </aside>
  );
};

export default LawyerSidebar;
